import React from "react";
import CaseCard from "./CaseCard";
import CaseDetails from "./CaseDetails";
import CasePhotos from "./CasePhotos";

const Case = ( {data} ) => {
    return(
        <div className="flex flex-col lg:p-5 p-3 lg:gap-28 md:gap-24 gap-14 ">
            {
                data.map((block) => {
                    switch(block.typeblock){
                        case 'casecard':
                            return <CaseCard data = {block.payload}/>;
                        case 'casedetails':
                            return <CaseDetails data = {block.payload}/>
                        case 'casephotos':
                            return <CasePhotos data = {block.payload}/>
                    }
                })
            }
        </div>
    );
};
export default Case;